export const ExclamationFadedCircle = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_6369_7023)">
      <rect x="4" y="4" width="40" height="40" rx="20" fill="#F9E8EA" />
      <rect
        x="4.5"
        y="4.5"
        width="39"
        height="39"
        rx="19.5"
        stroke="url(#paint0_linear_6369_7023)"
      />
      <g clip-path="url(#clip0_6369_7023)">
        <path
          d="M24 14C22.0222 14 20.0888 14.5865 18.4443 15.6853C16.7998 16.7841 15.5181 18.3459 14.7612 20.1732C14.0043 22.0004 13.8063 24.0111 14.1922 25.9509C14.578 27.8907 15.5304 29.6725 16.9289 31.0711C18.3275 32.4696 20.1093 33.422 22.0491 33.8079C23.9889 34.1937 25.9996 33.9957 27.8268 33.2388C29.6541 32.4819 31.2159 31.2002 32.3147 29.5557C33.4135 27.9112 34 25.9778 34 24C33.9971 21.3487 32.9426 18.8068 31.0679 16.9321C29.1932 15.0574 26.6513 14.0029 24 14ZM24 32.3333C22.3518 32.3333 20.7407 31.8446 19.3703 30.9289C17.9998 30.0132 16.9317 28.7117 16.301 27.189C15.6703 25.6663 15.5053 23.9908 15.8268 22.3742C16.1483 20.7577 16.942 19.2729 18.1074 18.1074C19.2729 16.942 20.7577 16.1483 22.3743 15.8268C23.9908 15.5052 25.6663 15.6703 27.189 16.301C28.7118 16.9317 30.0132 17.9998 30.9289 19.3702C31.8446 20.7407 32.3333 22.3518 32.3333 24C32.3309 26.2094 31.4522 28.3276 29.8899 29.8899C28.3276 31.4522 26.2094 32.3309 24 32.3333Z"
          fill="#BF1A2F"
        />
        <path
          d="M24 18.1667C23.7789 18.1667 23.567 18.2545 23.4107 18.4108C23.2544 18.5671 23.1666 18.7791 23.1666 19.0001V25.6667C23.1666 25.8878 23.2544 26.0997 23.4107 26.256C23.567 26.4123 23.7789 26.5001 24 26.5001C24.221 26.5001 24.4329 26.4123 24.5892 26.256C24.7455 26.0997 24.8333 25.8878 24.8333 25.6667V19.0001C24.8333 18.7791 24.7455 18.5671 24.5892 18.4108C24.4329 18.2545 24.221 18.1667 24 18.1667Z"
          fill="#BF1A2F"
        />
        <path
          d="M24.8333 29.0001C24.8333 28.5398 24.4602 28.1667 24 28.1667C23.5397 28.1667 23.1666 28.5398 23.1666 29.0001C23.1666 29.4603 23.5397 29.8334 24 29.8334C24.4602 29.8334 24.8333 29.4603 24.8333 29.0001Z"
          fill="#BF1A2F"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_6369_7023"
        x="0"
        y="0"
        width="48"
        height="48"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="4"
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_6369_7023"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.305882 0 0 0 0 0.305882 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6369_7023"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6369_7023"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6369_7023"
        x1="24"
        y1="4"
        x2="24"
        y2="44"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFA7A7" />
        <stop offset="1" stop-color="#FFA7A7" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_6369_7023">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(14 14)"
        />
      </clipPath>
    </defs>
  </svg>
);
